<template>
  <div class="cpm-wrapper">
    <el-tooltip effect="dark" placement="top" trigger="hover" :content="tip">
      <div>
        <img class="question" :src="require('@/assets/img/question-icon.png')" alt="" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    tip: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  display: inline-block;
  vertical-align: middle;
  padding-left: 8px;
  .question {
    height: 12px;
    width: 12px;
    border-radius: 6px;
  }
}
</style>
